import set from "lodash/set";

export const LOAN_FETCHED_DATA_TYPES = {
  LOAN_TERMS: "loanTerms",
  FUNDING_ENTITIES: "fundingEntities",
  UW_REQUIREMENTS: "uwRequirements",
  ESCROW_ITEMS: "escrowItems",
  PARSED_DOCS: "parsedDocs",
  EMAIL_TEMPLATES: "emailTemplates",
};

const initState = {
  [LOAN_FETCHED_DATA_TYPES.LOAN_TERMS]: null,
  [LOAN_FETCHED_DATA_TYPES.FUNDING_ENTITIES]: null,
  [LOAN_FETCHED_DATA_TYPES.UW_REQUIREMENTS]: null,
  [LOAN_FETCHED_DATA_TYPES.ESCROW_ITEMS]: null,
  [LOAN_FETCHED_DATA_TYPES.PARSED_DOCS]: null,
  [LOAN_FETCHED_DATA_TYPES.EMAIL_TEMPLATES]: null,
};

const loanFetchedDataReducer = (state = initState, action) => {
  let newState = { ...state };

  switch (action.type) {
    case "SET_LOAN_FETCHED_DATA_KEY":
      return set(newState, action.payload.key, action.payload.value);

    case "SET_LOAN_FETCHED_DATA_VALUES":
      return {
        ...newState,
        ...action.payload,
      };

    case "SET_LOAN_FETCHED_DATA_RESOURCE": {
      const { resourceKey, data } = action.payload;
      newState[resourceKey] = data;
      return newState;
    }

    case "CLEAR_LOAN_FETCHED_DATA_RESOURCE": {
      const resourceKey = action.payload;

      if (resourceKey in initState) {
        newState[resourceKey] = initState[resourceKey];
      }

      return newState;
    }

    case "CLEAR_LOAN_FETCHED_DATA":
      return initState;

    default:
      return state;
  }
};

export default loanFetchedDataReducer;

// ------------------- action creators -------------------

// generic
export const loanFetchedDataSetKey = (key, value) => ({
  type: "SET_LOAN_FETCHED_DATA_KEY",
  payload: { key, value },
});

export const loanFetchedDataSetValues = (values) => ({
  type: "SET_LOAN_FETCHED_DATA_VALUES",
  payload: values,
});

// fetched-resource convenience
export const loanFetchedDataSetResource = (resourceKey, data) => ({
  type: "SET_LOAN_FETCHED_DATA_RESOURCE",
  payload: { resourceKey, data },
});

export const loanFetchedDataClearResource = (resourceKey) => ({
  type: "CLEAR_LOAN_FETCHED_DATA_RESOURCE",
  payload: resourceKey,
});

// clears
export const loanFetchedDataClearAll = () => ({
  type: "CLEAR_LOAN_FETCHED_DATA",
});

// ###### ###### ######
//  ENDPOINT SPECIFIC
// ###### ###### ######

// Loan Terms
export const loanFetchedDataLoanTermsSet = (data) => ({
  type: "SET_LOAN_FETCHED_DATA_RESOURCE",
  payload: { resourceKey: LOAN_FETCHED_DATA_TYPES.LOAN_TERMS, data },
});

export const loanFetchedDataLoanTermsClear = () => ({
  type: "CLEAR_LOAN_FETCHED_DATA_RESOURCE",
  payload: { resourceKey: LOAN_FETCHED_DATA_TYPES.LOAN_TERMS },
});

// Loan Funding Entities
export const loanFetchedDataFundingEntitiesSet = (data) => ({
  type: "SET_LOAN_FETCHED_DATA_RESOURCE",
  payload: { resourceKey: LOAN_FETCHED_DATA_TYPES.FUNDING_ENTITIES, data },
});

export const loanFetchedDataFundingEntitiesClear = () => ({
  type: "CLEAR_LOAN_FETCHED_DATA_RESOURCE",
  payload: { resourceKey: LOAN_FETCHED_DATA_TYPES.FUNDING_ENTITIES },
});

// Loan Escrow Items
export const loanFetchedDataEscrowItemsSet = (data) => ({
  type: "SET_LOAN_FETCHED_DATA_RESOURCE",
  payload: { resourceKey: LOAN_FETCHED_DATA_TYPES.ESCROW_ITEMS, data },
});

export const loanFetchedDataEscrowItemsClear = () => ({
  type: "CLEAR_LOAN_FETCHED_DATA_RESOURCE",
  payload: { resourceKey: LOAN_FETCHED_DATA_TYPES.ESCROW_ITEMS },
});

// Loan Escrow Items
export const loanFetchedDataParsedDocsSet = (data) => ({
  type: "SET_LOAN_FETCHED_DATA_RESOURCE",
  payload: { resourceKey: LOAN_FETCHED_DATA_TYPES.PARSED_DOCS, data },
});

export const loanFetchedDataParsedDocsClear = () => ({
  type: "CLEAR_LOAN_FETCHED_DATA_RESOURCE",
  payload: { resourceKey: LOAN_FETCHED_DATA_TYPES.PARSED_DOCS },
});

// UW_REQUIREMENTS
export const loanFetchedDataUwRequirementsSet = (data) => ({
  type: "SET_LOAN_FETCHED_DATA_RESOURCE",
  payload: { resourceKey: LOAN_FETCHED_DATA_TYPES.UW_REQUIREMENTS, data },
});

export const loanFetchedDataUwRequirementsClear = () => ({
  type: "CLEAR_LOAN_FETCHED_DATA_RESOURCE",
  payload: { resourceKey: LOAN_FETCHED_DATA_TYPES.UW_REQUIREMENTS },
});

// EMAIL TEMPLATES
export const loanFetchedDataEmailTemplatesSet = (data) => ({
  type: "SET_LOAN_FETCHED_DATA_RESOURCE",
  payload: { resourceKey: LOAN_FETCHED_DATA_TYPES.EMAIL_TEMPLATES, data },
});

export const loanFetchedDataEmailTemplatesClear = () => ({
  type: "CLEAR_LOAN_FETCHED_DATA_RESOURCE",
  payload: { resourceKey: LOAN_FETCHED_DATA_TYPES.EMAIL_TEMPLATES },
});
